import { useState, useEffect, Fragment } from 'react';
import { Spinner } from "react-bootstrap";
import PdfViewer from '../../components/Global/PdfViewer';
import Modal from '../../components/Global/Modal';
import qr from '../../assets/images/commons_QR_code.png';
import useApi from '../../helpers/api'; 

const ShowTickets = (props) => {
    const [entradas, setEntradas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pdfVisible, setPdfVisible] = useState(false);
    const [pdfData, setPdfData] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [response, setResponse] = useState(null);
    const api = useApi();

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pdfShowHide = () => setPdfVisible(!pdfVisible);
    const modalShowHide = () => setModalVisible(!modalVisible);

    const getData = async () => {
        try {
            const response = await api.getEntradasInforme(localStorage.getItem('token'));
            setEntradas(response.filter(entrada=> entrada.idCompra === props.id));
        } catch (err) {
            console.error(err);
        }
    };

    const getTicket = async (ruta, download = false) => {
        if (!loading) {
            setLoading(true);
            const response = await api.getTicket(ruta, localStorage.getItem('token'));

            if (download) {
                const blobUrl = URL.createObjectURL(response);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = blobUrl;
                a.download = 'Ticket.pdf';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(blobUrl);
                setLoading(false);
            } else {
                setPdfData(URL.createObjectURL(response));
                setLoading(false);
                setTimeout(() => {
                    setPdfVisible(true);
                }, 10);
            }
        }
    };

    const reenviarMailCompra = async (idCompra) => {
        setLoading(true);
        const response = await api.reenviarMail(idCompra, localStorage.getItem('token'));
        if (response.status === 200) {
            setResponse(response.status);
            setModalVisible(true);
        }
        setLoading(false);
    };

    return (
        <Fragment>
            <Modal response={response} show={modalShowHide} modalShow={modalVisible}
                title={'Reenviar mail'} success={'Mail reenviado correctamente'} error={'Error al reenviar mail'} />
            <PdfViewer show={pdfShowHide} modalShow={pdfVisible} data={pdfData} />
            <div className="right-content shadow-lg">
                <div className="right-header">
                    <div className="d-flex justify-content-between align-items-center">
                        <h6>Entradas</h6>
                        <button className="btn p-0 btn-close-2" onClick={() => props.overlayShowHide()}>
                            <i className="fa fa-times"></i>
                        </button>
                    </div>
                </div>
                <div className="right-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                                <h6 className='m-0'>{props.cliente.nombre}</h6>
                                <p className='m-0'>{props.cliente.dni}</p>
                                <button disabled={loading} className='btn btn-primary me-2' onClick={() => reenviarMailCompra(props.id)}>
                                    {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Reenviar'}
                                </button>
                            </div>
                            <div className="divider mt-1 mb-3"></div>
                            {entradas.length === 0 ? <Spinner /> :
                                entradas.map((entrada) => (
                                    <Fragment key={entrada.id}>
                                        {entrada.fila > 0 ? (
                                            <>
                                                <div className='entrada-ticket d-flex justify-content-between'>
                                                    <div>
                                                        <p>Tipo: Platea</p>
                                                        <p>Zona: {entrada.zona} - Fila: {entrada.fila}</p>
                                                        <p>Asiento: {entrada.columna}</p>
                                                    </div>
                                                    <div className='qr d-flex flex-column justify-content-between align-items-end'>
                                                        <img className="mb-3" width={100} height={100} src={qr} alt='Qr' />
                                                        <div className='d-flex flex-row'>
                                                            <button disabled={loading} className='btn btn-primary me-2' onClick={() => getTicket(entrada.ruta_pdf, false)}>
                                                                {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Imprimir'}
                                                            </button>
                                                            <button disabled={loading} className='btn-outline-grey' onClick={() => getTicket(entrada.ruta_pdf, true)}>
                                                                {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Descargar'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="divider mt-5 mb-5"></div>
                                            </>
                                        ) : (
                                            <>
                                                <div className='entrada-ticket d-flex justify-content-between'>
                                                    <div>
                                                        <p>Tipo: General</p>
                                                    </div>
                                                    <div className='qr d-flex flex-column justify-content-between align-items-end'>
                                                        <img className='mb-3' width={100} height={100} src={qr} alt='Qr' />
                                                        <div className='d-flex flex-row'>
                                                            <button disabled={loading} className='btn btn-primary me-2' onClick={() => getTicket(entrada.ruta_pdf, false)}>
                                                                {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Imprimir'}
                                                            </button>
                                                            <button disabled={loading} className='btn btn-outline-grey' onClick={() => getTicket(entrada.ruta_pdf, true)}>
                                                                {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Descargar'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="divider mt-5 mb-5"></div>
                                                {/* {entrada.ruta_pdf_especial && (
                                                    <>
                                                        <div className='entrada-ticket d-flex justify-content-between'>
                                                            <div>
                                                                <p>Tipo: Bingo especial</p>
                                                            </div>
                                                            <div className='qr d-flex flex-column justify-content-between align-items-end'>
                                                                <img className='mb-3' width={100} height={100} src={qr} alt='Qr' />
                                                                <div className='d-flex flex-row'>
                                                                    <button disabled={loading} className='btn btn-primary me-2' onClick={() => getTicket(entrada.ruta_pdf_especial, false)}>
                                                                        {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Imprimir'}
                                                                    </button>
                                                                    <button disabled={loading} className='btn btn-outline-grey' onClick={() => getTicket(entrada.ruta_pdf_especial, true)}>
                                                                        {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Descargar'}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="divider mt-5 mb-5"></div>
                                                    </>
                                                )} */}
                                            </>
                                        )}
                                    </Fragment>
                                ))}
                        </div>
                    </div>
                </div>
                <div className="right-footer d-flex justify-content-center align-items-stretch">
                    <button disabled={loading} className="btn btn-outline-grey" onClick={() => props.overlayShowHide()}>Cancelar</button>
                </div>
            </div>
        </Fragment>
    );
};

export default ShowTickets;
